import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { MainButton } from '../Button/MainButton'

const useStyles = makeStyles((theme) => ({
    dialogActions: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '0px 0px 0px 0px',
        marginTop: 24
    },
    dialogActions2: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        padding: '0px 0px 0px 0px',
        marginTop: 24
    },
    dialogText: {
        font: 'Nunito',
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '21.82 px'
    }
}))

const ModeDialog = (props) => {
    const classes = useStyles()

    const [capacity, setCapacity] = useState(0)
    const [max, setMax] = useState(0)

    let {
        isShown,
        setIsShown,
        title = 'Delete',
        isDeleteLoading,
        currentDay,
        counts,
        holidays,
        confirmSave,
        openConfirmModal,
        setOpenConfirmModal,
        closeDay,
        facility
    } = props

    const { block_type, date, status } = currentDay

    const getCapacity = () => {


		let capacity = facility?.capacity?.total || 150
		if (block_type === 'daycare') {
			const { daycare_days } = facility.capacity
			const day_of_week = moment(date, 'YYYY-MM-DD').format('dddd')
			const weekday_cap = daycare_days[day_of_week]
			if (weekday_cap) {
				capacity = weekday_cap
			} else {
				capacity = facility?.capacity?.daycare_only || 150
			}
		}

		let dayOfWeek = moment(date).format('dddd')

		if (block_type === 'daytime') capacity = facility?.capacity?.daytime || 150
		if (block_type === 'overnight') capacity = facility?.capacity?.overnight || 150
		if (block_type === 'daycare_with_boarding') capacity = null
		if (block_type === 'overflow') capacity = null
		if (block_type === 'welcome') capacity = facility?.capacity?.welcome_day || 10

        let originalCapacity = capacity
		let updatedCapacity = null

		if (['daycare', 'welcome', 'overnight'].includes(block_type)) {
			let hasManualCapacity =  counts?.[date]?.autoCaps?.find(ac => !!ac.hasOwnProperty('capacity') && ac.type === block_type)
			if (hasManualCapacity) updatedCapacity = hasManualCapacity.capacity
		}

		if (updatedCapacity || updatedCapacity === 0) return updatedCapacity

        return capacity
	}

    useEffect(() => {

        if (currentDay?.block_type && facility) {
            let cap = getCapacity()

            setCapacity(cap)

            let ourMax = facility?.capacity?.total || 150
            setMax(ourMax)
        }


    }, [facility, currentDay])


    const save = (confirmed) => {
       return confirmSave({ ...currentDay, status: '', capacity })
    }

    useEffect(() => {
        if (!isShown) {
            setOpenConfirmModal(false)
        }
    }, [isShown])

    const renderConfirmMessage = () => {
        if (!openConfirmModal) return

        const titles = {
			'total': 'Facility Total',
			'total_daytime': 'Total Daytime',
			'daycare': 'Daycare',
			'welcome': 'Welcome Day',
			'daycare_with_boarding': 'Daycare w/Boarding',
			'overnight': 'Overnight',
			'overflow': 'Overflow'
		}

        if (status?.toLowerCase() === 'closed') {
            return (
                <Typography variant="body1" className={classes.dialogText}>
                Are you sure you want to open availability for <strong style={{ fontWeight: '800' }}>{titles[currentDay?.block_type]}</strong> on <strong style={{ fontWeight: '800' }}>{moment(currentDay?.date).format('MMM DD, YYYY')}?</strong>
            </Typography>
            )
        }

        return (
            <Typography variant="body1" className={classes.dialogText}>
                Are you sure you want to close availability for <strong style={{ fontWeight: '800' }}>{titles[currentDay?.block_type]}</strong> on <strong style={{ fontWeight: '800' }}>{moment(currentDay?.date).format('MMM DD, YYYY')}?</strong> Doing so will prevent clients from booking any more daytime services on that day.
            </Typography>
        )
    }

    return (
        <Dialog
            open={isShown}
            className={classes.dialog}
            onClose={() => {
                if (!isDeleteLoading) setIsShown(false)
            }}
            PaperProps={{
                style: {
                    minWidth: '580px',
                    maxWidth: '580px',
                    width: '580px'
                }
            }}>
            <DialogTitle>
                <Typography
                    style={{
                        fontFamily: 'Nunito',
                        color: '#1A1A35',
                        fontSize: '16px',
                        lineHeight: '22px',
                        textTransform: 'uppercase',
                        fontWeight: '800',
                        marginBottom: 16
                    }}>
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 0 }}>
                {
                    !openConfirmModal && <TextField
                        label="Dog Capacity"
                        value={capacity}
                        type="number"
                        disabled={block_type === 'total_daytime'}
                        style={{ width: '100%', marginBottom: 16, textTransform: 'capitalize' }}
                        onChange={(e) => {
                            if (e.target.value <= max) setCapacity(e.target.value)
                        }}
                        variant="filled"/>
                }
                { renderConfirmMessage() }
                {
                    openConfirmModal ? (
                        <DialogActions className={classes.dialogActions2}>
                            <MainButton
                                variant="contained"
                                label={'CONFIRM'}
                                backgroundColor="#EB4C4C"
                                onClick={() => {
                                    const newStatus = status === 'Closed' ? 'Open' : 'Closed'
                                    closeDay({ block_type, date, status: newStatus })
                                    setOpenConfirmModal(false)
                                    setIsShown(false)
                                }}
                            />
                            <MainButton
                                variant="outlined"
                                label="CANCEL"
                                onClick={() => setIsShown(false)}
                                disabled={isDeleteLoading}
                            />
                        </DialogActions>
                    ) : (

                        <DialogActions className={classes.dialogActions}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <MainButton
                                    variant="contained"
                                    label={'SAVE'}
                                    backgroundColor="#6B4AD6"
                                    onClick={() => save(false)}
                                    disabled={false}
                                    style={{ marginRight: 12, height: 40 }}
                                />
                                <MainButton
                                    variant="outlined"
                                    label="CANCEL"
                                    onClick={() => setIsShown(false)}
                                    disabled={isDeleteLoading}
                                    style={{ marginRight: 12, height: 40 }}
                                />
                            </div>
                        {/*block_type === 'total_daytime' && (
                            <MainButton 
                                variant='secondary'
                                label={status?.toLowerCase() === 'closed' ? 'Open Availability' : "Close Availability"}
                                onClick={() => setOpenConfirmModal(true)}
                                style={{ fontSize: 14, color: '#D02C2C' }}
                            />
                            )
                        */}
                        </DialogActions>
                    )
                }
            </DialogContent>
        </Dialog>
    )
}

export default ModeDialog